import { Text } from "@merge-api/merge-javascript-shared";
import SimpleCategoryCell from "../../../shared/SimpleCategoryCell";
import { AdminCategory } from "../../../../../models/Categories";
// import useIntegrationBuilderContext from "src/components/integration-builder/context/useIntegrationBuilderContext";

interface Props {
  commonModelID: string;
  alignIconLeft?: boolean;
  isBold?: boolean;
}

const CommonModelDisplay = ({ commonModelID, alignIconLeft = false, isBold = false }: Props) => {
  const category = commonModelID?.split(".")[0];
  const commonModelName = commonModelID?.split(".")[1];
  // const { markedForDeletion } = useIntegrationBuilderContext();

  return (
    <div className="flex flex-row items-center gap-2">
      {alignIconLeft && <SimpleCategoryCell category={category as AdminCategory} />}
      <Text className="text-gray-40" variant={isBold ? "h6" : "md"}>
        {commonModelName}
      </Text>
      {!alignIconLeft && <SimpleCategoryCell category={category as AdminCategory} />}
    </div>
  );
};

export default CommonModelDisplay;
